import React from 'react';
import PropTypes from 'prop-types';

import ToggleButton from 'components/ToggleButton';

import SquareButton from '../../../../SquareButton';

const SatelliteButton = ({ value, onToggle }) => {
  return (
    <SquareButton
      onClick={() => {}}
      buttonClassName="h-6 px-2 text-xs font-medium rounded"
    >
      <div className="mr-2">SAT</div>
      {value ? (
        <button
          data-testid="sat-done-button"
          className="text-sm pl-1 pr-1"
          type="button"
          onClick={onToggle}
          style={{
            backgroundColor: '#19A04B',
            color: 'white',
            paddingBottom: '0.13rem'
          }}
        >
          Done
        </button>
      ) : (
        <ToggleButton
          id="map-satellite-toggle"
          name="map-satellite-toggle"
          defaultChecked={value}
          onChange={onToggle}
          color="#0071CD"
        />
      )}
    </SquareButton>
  );
};

SatelliteButton.propTypes = {
  value: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired
};

export default SatelliteButton;
